module.exports = __webpack_public_path__ + "static/media/effet1.280b58f1.ogg";